// extracted by mini-css-extract-plugin
export var aircallIframe = "_my-3";
export var fabContainer = "_my-5";
export var fabRinging = "_my-6";
export var loadingOverlay = "_my-4";
export var pulse = "_my-7";
export var widgetContent = "_my-2";
export var widgetPanel = "_my-0";
export var widgetPanelExpanded = "_my-1";